import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Snackbars from "./Snackbars";

const EmailOtp = () => {
  const { qrcode_id } = useParams();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const handleVerifyOtp = async () => {
    if (!otp) {
      setError("Please enter the OTP.");
      return;
    }
    setLoading(true);
    setError("");

    try {
      const headers = {
        "Content-Type": "application/json",
        "app-token": process.env.REACT_APP_TOKEN_SECRET,
      };
      const payload = { otp: otp };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/v1/scanner/verify-email-otp/${qrcode_id}`,
        payload,
        { headers: headers }
      );
      const res = response.data;

      if (res.code === 200) {
        navigate(`/confirm-ticket/${qrcode_id}`);
      } else {
        setAlertData({
          variant: "error",
          message: res.message,
        });
        resetAlertData();
      }
    } catch (error) {
      setAlertData({
        variant: "error",
        message: "Something went Wrong.",
      });
      resetAlertData();
    }
    setLoading(false);
  };

  const handleResendOtp = async () => {
    setResendLoading(true);
    setError("");

    try {
      const headers = {
        "Content-Type": "application/json",
        "app-token": process.env.REACT_APP_TOKEN_SECRET,
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/v1/scanner/send-email-otp/${qrcode_id}`,
        { headers: headers }
      );
      const res = response.data;

      if (res.code === 200) {
        //go to email-otp page
        setAlertData({
          variant: "success",
          message: res.message,
        });
        resetAlertData();
      } else {
        setAlertData({
          variant: "error",
          message: res.message,
        });
        resetAlertData();
      }
    } catch (error) {
      setAlertData({
        variant: "error",
        message: "Something went Wrong.",
      });
      resetAlertData();
    }
    setResendLoading(false);
    setError("");
  };

  const handlesendOtp = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        "app-token": process.env.REACT_APP_TOKEN_SECRET,
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}api/v1/scanner/send-email-otp/${qrcode_id}`,
        { headers: headers }
      );
      const res = response.data;

      if (res.code === 200) {
        setAlertData({
          variant: "success",
          message: res.message,
        });
        resetAlertData();
      } else {
        setAlertData({
          variant: "error",
          message: res.message,
        });
        resetAlertData();
      }
    } catch (error) {
      setAlertData({
        variant: "error",
        message: "Something went Wrong.",
      });
      resetAlertData();
    }
  };

  useEffect(() => {
    handlesendOtp();
  }, []);

  return (
    <>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}

      <div className="otp-page">
        <div className="otp-container">
          <h2>Email OTP Verification</h2>
          <p>Enter the OTP sent to your email.</p>
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
            maxLength="6"
            className="otp-input"
          />
          {error && <p className="error-text">{error}</p>}
          <button
            onClick={handleVerifyOtp}
            disabled={loading}
            className="otp-button"
          >
            {loading ? "Verifying..." : "Verify OTP"}
          </button>

          <p className="resend-text">
            <button
              onClick={handleResendOtp}
              disabled={resendLoading}
              className="resend-button"
            >
              {resendLoading ? "Resending..." : "Resend OTP"}
            </button>
          </p>
        </div>
      </div>
    </>
  );
};

export default EmailOtp;
